import React, { createContext, useContext, useReducer, ReactNode } from 'react'

interface SuccessToastState {
  message: string | null
}

type SuccessToastAction =
  | { type: 'SHOW_TOAST'; payload: string }
  | { type: 'HIDE_TOAST' }

const initialState: SuccessToastState = {
  message: null,
}

function successToastReducer(
  state: SuccessToastState,
  action: SuccessToastAction,
): SuccessToastState {
  switch (action.type) {
    case 'SHOW_TOAST':
      return {
        ...state,
        message: action.payload,
      }
    case 'HIDE_TOAST':
      return {
        ...state,
        message: null,
      }
    default:
      return state
  }
}

interface SuccessToastContextType extends SuccessToastState {
  showToast: (message: string) => void
  hideToast: () => void
}

const SuccessToastContext = createContext<SuccessToastContextType | undefined>(
  undefined,
)

export function SuccessToastProvider({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(successToastReducer, initialState)

  const showToast = (message: string) => {
    dispatch({ type: 'SHOW_TOAST', payload: message })
  }

  const hideToast = () => {
    dispatch({ type: 'HIDE_TOAST' })
  }

  return React.createElement(
    SuccessToastContext.Provider,
    { value: { ...state, showToast, hideToast } },
    children,
  )
}

export function useSuccessToast() {
  const context = useContext(SuccessToastContext)
  if (context === undefined) {
    throw new Error(
      'useSuccessToast must be used within a SuccessToastProvider',
    )
  }
  return context
}
